export default "__VITE_ASSET__C_KaF0oo__"